<template>
    <div>
        <component
            :is="tabComponents[tab]"
            v-if="tab !== 'group'"
            :list="messages[tab]"
            :is-all="tab === 'all'"
            :tab="tab"
            :folders="folders"
            :key="`${tab}_list`"
        />

        <div v-else class="tab-content">
            <ans-select
                id="group-filter"
                v-model="data.GroupID"
                :options="options.group"
                input-class="custom-border"
                remove-empty-option
                :on-change="handleGroupChange"
            />

            <div class="pt-16-px">
                <MessageList v-if="messages.group && messages.group.length > 0" :list="messages.group" />
                <div v-else class="no-matching-group">該当するグループメッセージがありません</div>
            </div>
        </div>
    </div>
</template>

<script>
import MessageList from './MessageList.vue';
import { mapState } from 'vuex';

export default {
    name: 'MessageListSection',
    components: { MessageList },
    props: {
        tab: { type: String, default: '' },
        messages: { type: Object, required: true },
        tabComponents: { type: Object, required: true },
        folders: { type: Array, default: () => [] }
    },
    computed: { ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']), ...mapState('MNG_DM_Message_Store', ['data', 'options']) },
    methods: {
        handleGroupChange() {
            this.$emit('filter-group-message');
        }
    }
};
</script>
